import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Tab,
  Nav,
  Dropdown,
  Form,
  Col,
  Row,
  FormGroup,
  Card,
} from "react-bootstrap";
import { studentdashboardcount, studentview } from "../../../services/student";
import moment from "moment";
import { listtimetable, listsetting } from "../../../services/admin";
import { toast } from "react-toastify";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { AgGridReact } from "ag-grid-react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Studentmyprofile() {
  const baseUrl = (localStorage.getItem("activeBaseUrl") || "").replace("/api", "");
  const [activeTab, setActiveTab] = useState("tab1");
  const { id } = useParams();
  const [sdetail, setSDetail] = useState('');
  const [hdetail, setHDetail] = useState('');
  const [adetail, setADetail] = useState([]);
  const [periods, setPeriod] = useState([]);
  const [sfees, setSFees] = useState([]);
  const [edetail, setEDetail] = useState([]);
  const [attdet, setAttdet] = useState([]);
  const [calatt, setCalAtt] = useState([]);
  const [hwlist, setHWList] = useState([]);

  const [flist, setFList] = useState([]);
  const [fhlist, setFHList] = useState([]);


  const [pwsd, setPwsd] = useState("");


  const [hwpath, setHPath] = useState("");
  const [spath, setSPath] = useState("");
  const [tpath, setTPath] = useState("");
  const [qrpath, setQRPath] = useState("");

  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [certList, setCertList] = useState([]);
  const [headerUrl, setHeaderUrl] = useState("");
  const [footerUrl, setFooterUrl] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [schoolAddress, setSchoolAddress] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  useEffect(() => {
    // setFDate(moment(new Date()).format("YYYY-MM-DD"));
    setFDate(moment().startOf("month").format("YYYY-MM-DD"));
    setTDate(moment(new Date()).format("YYYY-MM-DD"));
    studentview(id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res) => {
      if (res.status === true) {
        setSDetail(res.data.details);
        setPwsd(res.data.password);
        setHDetail(res.data.hostel);
        setADetail(res.data.attendance);
        const adata = res.data.attendance.filter((item) => item.attendance.length > 0);
        setAttdet(adata);
        const adetail = res.data.attendance;
        const events = [];
        if (adetail && adetail.length > 0) {

          adetail.forEach((yearItem) => {

            if (yearItem.attendance && yearItem.attendance.length > 0) {

              yearItem.attendance.forEach((att) => {

                let title = "";
                let bgColor = "";

                // Present
                if (att.attend_status === 1) {
                  title = `P - ${att.attendance_time}`;
                  bgColor = "#28a745"; // Green
                }

                // Absent
                else if (att.attend_status === 0) {
                  title = `A - ${att.attendance_time}`;
                  bgColor = "#dc3545"; // Red
                }

                // Half Day (Optional)
                else {
                  title = `H - ${att.attendance_time}`;
                  bgColor = "#ffc107"; // Yellow
                }

                events.push({
                  id: att.id,
                  title: title,
                  start: att.attendance_date,
                  allDay: true,
                  backgroundColor: bgColor,
                  borderColor: bgColor,
                  textColor: "#fff",
                });
              });
            }
          });
        }

        setCalAtt(events);
        setSPath(res.data.path);
        setQRPath(res.data.qrpath);
        setSFees(res.data.feesamount);

        if (res.data.feeslist.length > 0) {
          const cdata = res.data.feeslist.map((item) => {
            return {
              ...item,
              paid_date: moment(item.paid_date).format("DD-MM-YYYY"),
            }
          });
          setFList(cdata);
        }
        if (res.data.feeshistory.length > 0) {
          const cdata = res.data.feeshistory.map((item) => {
            return {
              ...item,
              payment_date: moment(item.payment_date).format("DD-MM-YYYY"),
            }
          });
          setFHList(cdata);
        }
        setEDetail(res.data.examdetails);
        setHWList(res.data.homework);
        setHPath(res.data.homepath);
        setTPath(res.data.tpath);

        if (res.data.details !== null) {
          if (res.data.certificates) setCertList(res.data.certificates);
          const aca = res.data.details.academy_id || localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
          const settTemp = new FormData();
          settTemp.append("academy_id", aca);
          listsetting(settTemp).then((resp) => {
            if (resp?.status && resp.data) {
              if (resp.data.certificate_header) setHeaderUrl(baseUrl + "/" + resp.data.certificate_header);
              if (resp.data.certificate_footer) setFooterUrl(baseUrl + "/" + resp.data.certificate_footer);
              setSchoolName(resp.data.school_name || "");
              setSchoolAddress(resp.data.address || "");
            }
          });
        }

        if (res.data.details !== null) {
          const temp = new FormData();
          temp.append("user_id", res.data.details.user_id);
          temp.append("year", res.data.details.academicyear);
          studentdashboardcount(temp).then((res) => {
            if (res.status === true) {
              const periodMap = {};

              res.data.timetable.forEach(entry => {
                const key = `${entry.period}_${entry.from_time}`;

                if (!periodMap[key]) {
                  periodMap[key] = {
                    period: entry.period,
                    slot_name: entry.slot_name,
                    from_time: entry.from_time,
                    to_time: entry.to_time,
                    is_break: entry.is_break,
                    schedule: {
                      Monday: null,
                      Tuesday: null,
                      Wednesday: null,
                      Thursday: null,
                      Friday: null,
                      Saturday: null,
                    },
                  };
                }

                periodMap[key].schedule[entry.day] = {
                  subject_name: entry.subject_name,
                  teacher_name: entry.teacher_name,
                  teacher_photo: entry.teacher_photo,
                };
              });

              let arr = Object.values(periodMap).sort((a, b) => a.period - b.period);

              setPeriod(arr);
            }
          })

          // const temp = new FormData();
          // temp.append("class", res.data.details.class_id);
          // temp.append("year", res.data.details.academicyear);
          // temp.append("section", res.data.details.section_id);
          // temp.append("type", 'Students');
          // listtimetable(temp).then((res1) => {
          //   if (res1.status === true) {

          //     if (res1.data.length > 0) {
          //       let arr = [];
          //       for (let i = 0; i < res1.data.length; i++) {
          //         arr.push({
          //           id: res1.data[i].id,
          //           time: res1.data[i].timeperiod,
          //           name: res1.data[i].t_lecture,
          //           academy: res1.data[i].academy_name,
          //           schedule: [
          //             res1.data[i].monday,
          //             res1.data[i].tuesday,
          //             res1.data[i].wednesday,
          //             res1.data[i].thursday,
          //             res1.data[i].friday,
          //             res1.data[i].saturday,
          //           ],
          //         });
          //       }
          //       setPeriod(arr);
          //     }
          //   }
          // });
        }

      }
    });
  }, []);



  const prepareChartData = (data) => {
    const feeTypes = data.year.map(fee => fee.type);
    const totalAmounts = data.year.map(fee => parseFloat(fee.total_amount));
    const paidAmounts = data.year.map(fee => parseFloat(fee.paid_amount));
    const pendingAmounts = data.year.map(fee => parseFloat(fee.pending_amount));

    const totalFeeAmount = totalAmounts.reduce((acc, amount) => acc + amount, 0);
    const totalPaidAmount = paidAmounts.reduce((acc, amount) => acc + amount, 0);
    const totalPendingAmount = pendingAmounts.reduce((acc, amount) => acc + amount, 0);
    feeTypes.push("Total Fees");
    totalAmounts.push(totalFeeAmount);
    paidAmounts.push(totalPaidAmount);
    pendingAmounts.push(totalPendingAmount);


    return {
      labels: feeTypes,
      datasets: [
        {
          label: 'Total Amount',
          data: totalAmounts,
          backgroundColor: 'rgba(75, 192, 192, 0.5)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        },
        {
          label: 'Paid Amount',
          data: paidAmounts,
          backgroundColor: 'rgba(54, 162, 235, 0.5)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1
        },
        {
          label: 'Pending Amount',
          data: pendingAmounts,
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1
        }
      ]
    };
  };
  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        // text: 'Fee Breakdown by Type',
        font: {
          size: 20
        }
      },
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ₹${context.raw.toFixed(2)}`;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      }
    }
  };

  const calculateGrandTotal = (details) => {
    return details.reduce((total, detail) => {
      const theoryMarks = parseInt(detail.exam_details_theory_mark) || 0;
      const practicalMarks = parseInt(detail.exam_details_pratical_mark) || 0;
      return total + theoryMarks + practicalMarks;
    }, 0);
  };

  // Function to calculate Total Obtained Marks
  const calculateTotalObtainedMarks = (details) => {
    return details.reduce((total, detail) => {
      const theoryMarks = parseInt(detail.theory_mark) || 0;
      const practicalMarks = parseInt(detail.practical_mark) || 0;
      return total + theoryMarks + practicalMarks;
    }, 0);
  };

  // Function to calculate Percentage
  const calculatePercentage = (details) => {
    const totalObtainedMarks = calculateTotalObtainedMarks(details);
    const grandTotal = calculateGrandTotal(details);
    return grandTotal > 0 ? ((totalObtainedMarks / grandTotal) * 100).toFixed(2) : 0;
  };
  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  function errorhome(ev) {
    ev.target.src = require("../../../assets/images/photo.png");
    ev.target.onerror = null;
  }

  function listall(fdte, tdte) {
    setFDate(fdte);
    setTDate(tdte);
    setHWList([]);
    studentview(id, fdte, tdte).then((res) => {
      if (res.status === true) {
        setHWList(res.data.homework);
      }
    })
  }
  const columnDefs = [
    {
      headerName: "Fee Type",
      field: "fees_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "paid_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },

    },
    {
      headerName: "Academic Year",
      field: "aca_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Total Amount",
      field: "total_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Paid Amount",
      field: "paid_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Discount Amount",
      field: "disc_amt",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Payment Method",
      field: "payment",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnHDefs = [
    {
      headerName: "Fee Type",
      field: "fees_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "payment_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Academic Year",
      field: "aca_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },

    {
      headerName: "Total Amount",
      field: "total_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Paid Amount",
      field: "payment_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Discount Amount",
      field: "disc_amt",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Payment Method",
      field: "payment_method",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Student Profile</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Students</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Student Profile
          </li>
        </ol>
      </div>

      <div className="main-container container-fluid">
        {localStorage.getItem("Role") !== "4" &&
          <div className="res-right me-2">
            <a className="btn btn-secondary" onClick={() => navigate(-1)}>
              Back
            </a>
          </div>

        }

        <div className="inner-body mt-2">
          <div className="row row-sm">
            <div className="col-xl-3 col-lg-12 col-md-12">
              <div className="card custom-card">
                <div className="card-body text-center item-user">
                  <div className="profile-pic">
                    <div className="profile-pic-img">
                      <img
                        alt="avatar"
                        className="rounded-circle"
                        src={sdetail && sdetail.photo !== null ? spath + sdetail.photo : require("../../../assets/images/user.png")}
                      />
                    </div>
                    <a href="#" className="text-dark">
                      <h5 className="mt-3 mb-0 font-weight-semibold">
                        {sdetail ? sdetail.student_name : ""}
                      </h5>
                    </a>
                  </div>
                </div>
                {/* Profile Info */}
                <ul className="item1-links nav nav-tabs mb-0">
                  <li className="nav-item">
                    <a className="float-end">{sdetail ? sdetail.class_name : ""} - {sdetail ? sdetail.section_name : ""}</a>
                    <a className="nav-link">
                      <i className="ti-save-alt icon1"></i> Class
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="float-end">{sdetail ? moment(sdetail.date_of_birth).format("DD-MM-YYYY") : ""}</a>
                    <a className="nav-link">
                      <i className="fa fa-calendar"></i> DOB
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="float-end">{sdetail ? sdetail.gender : ""}</a>
                    <a className="nav-link">
                      <i className="fa fa-user-o"></i> Gender
                    </a>
                  </li>
                  {sdetail && sdetail.resident_type == 3 &&
                    <li className="nav-item">
                      <a className="float-end">-</a>
                      <a className="nav-link">
                        <i className="ti-truck icon1"></i> Bus No
                      </a>
                    </li>
                  }

                  {/* <li className="nav-item">
                    <a className="float-end">
                      <img
                        // src={require("../../../assets/images/amy barcode.png")}
                        alt="Barcode"
                      />
                    </a>
                    <a className="nav-link">
                      <i className="fa fa-barcode"></i> Barcode
                    </a>
                  </li> */}
                  {sdetail && sdetail.qr_code !== null &&
                    <li className="nav-item">
                      <a className="float-end">
                        <img
                          alt="avatar"
                          className="rounded-circle"
                          src={sdetail && sdetail.qr_code !== null ? qrpath + sdetail.qr_code : require("../../../assets/images/qr_code.jpg")}
                        />
                      </a>
                      <a className="nav-link">
                        <i className="fa fa-qrcode"></i> QR
                      </a>
                    </li>
                  }


                  {localStorage.getItem("Role") < 3 && (
                    <>
                      <li className="nav-item">
                        <a className="float-end">{sdetail ? sdetail.username : ""}</a>
                        <a className="nav-link">
                          <i className="ti-user icon1"></i> Username
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="float-end">{pwsd}</a>
                        <a className="nav-link">
                          <i className="ti-lock icon1"></i> Password
                        </a>
                      </li>
                    </>
                  )

                  }
                </ul>
              </div>
            </div>

            {/* Right Tabs Section */}
            <div class="col-xl-9 col-lg-12 col-md-12">
              <div class="card custom-card mg-b-20" id="tabs-style2">
                <div class="card-body">
                  <div className="tabs-container">
                    {/* Tab Headers */}
                    <div className="tabs-menu">
                      <button
                        className={`text-white tab-button ${activeTab === "tab1" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab1")}
                      >
                        <i className="mdi mdi-account-box-outline"></i> Profile
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab2" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab2")}
                      >
                        <i className="mdi mdi-account-multiple"></i> Parents Detail
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab3" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab3")}
                      >
                        <i class="mdi mdi-account-check headericons"></i> Attendance
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab4" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab4")}
                      >
                        <i class="fa fa-calendar headericons"></i> Time Table
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab5" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab5")}
                      >
                        <i class="fa fa-book headericons"></i> HomeWork
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab6" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab6")}
                      >
                        <i class="fa fa-pencil-square-o headericons"></i> Examination
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab7" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab7")}
                      >
                        <i class="fa fa-money headericons"></i> Fee
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab8" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("tab8")}
                      >
                        <i class="fa fa-list headericons"></i> Fee History
                      </button>
                      <button
                        className={`text-white tab-button ${activeTab === "tab9" ? "active" : ""}`}
                        onClick={() => handleTabClick("tab9")}
                      >
                        <i className="fa fa-certificate headericons"></i> Certificates
                      </button>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content">
                      {activeTab === "tab1" && (
                        <div className="row">
                          <div className="card custom-card mg-t-15 col-xl-12 col-lg-12 col-md-12">
                            <Card className="custom-card body-bg">
                              <Card.Header>
                                <div className="d-md-flex ms-auto">
                                  <label className="main-content-label my-auto pt-2"> <i className="fa fa-user headericons"></i> Personal Detail</label>
                                </div>
                              </Card.Header>
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                  <Card.Body>
                                    <Form className="form-horizontal">
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Name <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.student_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              DOB <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? moment(sdetail.date_of_birth).format("DD-MM-YYYY") : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Blood Group{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.blood_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              E mail{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.primary_email : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Phone No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.phone : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Aadhar No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.aadhar_no : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              EMIS No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.emis_no : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>

                                    </Form>
                                  </Card.Body>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                  <Card.Body>
                                    <Form className="form-horizontal">
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Categaory{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.cat_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Religion{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.rel_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Caste{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.caste_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Sub Caste{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.subcaste_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Mother Tongue <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.mother_tongue : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Address
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.address1 : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group mb-0">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Pin Code{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.pincode : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                    </Form>
                                  </Card.Body>
                                </div>
                              </div>
                            </Card>
                            <Card className="custom-card body-bg">
                              <Card.Header className="">
                                <div className="d-md-flex ms-auto">
                                  <label className="main-content-label my-auto pt-2"> <i className="fa fa-building headericons"></i> Academy Detail</label>
                                </div>
                              </Card.Header>
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                  <Card.Body>
                                    <Form className="form-horizontal">

                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Unique Number{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.username : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Admission No <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.admission_number : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Roll No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.roll_number : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Academic Year <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.aca_year : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                    </Form>
                                  </Card.Body>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                  <Card.Body>
                                    <Form className="form-horizontal">
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Pre Institute {" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.institute_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Pre Medium{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.medium_name : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Pre TC No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.tc_number : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Admission Date{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? moment(sdetail.admission_date).format("DD-MM-YYYY") : ""}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>

                                    </Form>
                                  </Card.Body>
                                </div>
                              </div>
                            </Card>
                          </div>
                          {sdetail && sdetail.resident_type == '3' &&
                            <div className="card custom-card col-xl-6 col-lg-6 col-md-12">
                              <Card className="custom-card body-bg">
                                <Card.Header>
                                  <div className="d-md-flex ms-auto">
                                    <label className="main-content-label my-auto pt-2"> <i className="fa fa-bus headericons"></i> Transport Detail</label>
                                  </div>
                                </Card.Header>
                                <Card.Body>
                                  <Form className="form-horizontal">
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Vehicle Number <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {sdetail ? sdetail.vehicle_no : ""}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Driver <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {sdetail ? sdetail.worker_name : ""}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Vehicle Route{" "}
                                            <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {sdetail ? sdetail.vehroute_name : ""}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Mobile No{" "}
                                            <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {sdetail ? sdetail.worker_phone : ""}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>

                                  </Form>
                                </Card.Body>
                              </Card>
                            </div>
                          }

                          {sdetail && sdetail.resident_type == '2' &&
                            <div className="card custom-card col-xl-6 col-lg-6 col-md-12">
                              <Card className="custom-card body-bg">
                                <Card.Header>
                                  <div className="d-md-flex ms-auto">
                                    <label className="main-content-label my-auto pt-2"> <i className="fa fa-bed headericons"></i> Hostel Detail</label>
                                  </div>
                                </Card.Header>
                                <Card.Body>
                                  <Form className="form-horizontal">
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Hostel <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {hdetail ? hdetail.hostel_name : ''}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Room No <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {hdetail ? hdetail.room_no : ''}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Warden{" "}
                                            <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {hdetail ? hdetail.worker_name : ''}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                      <Row className="row-sm">
                                        <Col md={5} sm={5}>
                                          <h3 className="studentdetail-a">
                                            Admission date{" "}
                                            <span className="pull-end">:</span>
                                          </h3>
                                        </Col>
                                        <Col md={7} sm={7}>
                                          <h3 className="student-detail-b">
                                            {hdetail ? moment(hdetail.hostel_date).format('DD-MM-YYYY') : ''}
                                          </h3>
                                        </Col>
                                      </Row>
                                    </FormGroup>

                                  </Form>
                                </Card.Body>
                              </Card>
                            </div>
                          }

                        </div>

                      )}
                      {activeTab === "tab2" && (
                        <div className="row">
                          <div className="col-xl-12 col-lg-12 col-md-12 mg-t-15">
                            <Card className="custom-card body-bg">
                              <Card.Header>
                                <div className="d-md-flex ms-auto">
                                  <label className="main-content-label my-auto pt-2"> <i className="mdi mdi-account-multiple headericons"></i> Parents Detail</label>
                                </div>
                              </Card.Header>
                              <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                  <Card.Body>
                                    <Form className="form-horizontal">
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Father Name <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.father_name : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Mother Name <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.mother_name : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Guardian <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.guardian_name : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Email{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.parent_email : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>

                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Phone No{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.parent_phone : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Qualification{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.qualification : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Occupation{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.occupation : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Annual Income{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              ₹ {sdetail ? sdetail.annual_income : ''} /-
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                      <FormGroup className="form-group">
                                        <Row className="row-sm">
                                          <Col md={5} sm={5}>
                                            <h3 className="studentdetail-a">
                                              Permanent Address{" "}
                                              <span className="pull-end">:</span>
                                            </h3>
                                          </Col>
                                          <Col md={7} sm={7}>
                                            <h3 className="student-detail-b">
                                              {sdetail ? sdetail.permanent_address : ''}
                                            </h3>
                                          </Col>
                                        </Row>
                                      </FormGroup>
                                    </Form>
                                  </Card.Body>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12">

                                </div>
                              </div>
                            </Card>

                          </div>
                        </div>
                      )}
                      {/* {activeTab === "tab3" && (
                        <div className="col-sm-12 col-lg-12 col-xl-12">
                          {adetail && adetail.length > 0 &&
                            adetail.map((item, index) => (
                              <div key={index} className="row row-cards mt-1">
                                {item.attendance.length > 0 &&
                                  <>
                                    <h5>{item.year}</h5>
                                    <div className="row">
                                      <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">

                                        <div className="card bg-custom">
                                          <div className="card-body text-center feature">
                                            <p className="card-text mt-2">
                                              <strong>Total Days</strong>
                                            </p>
                                            <p className="h3 text-center text-info">{item.total_days}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div className="card bg-custom">
                                          <div className="card-body text-center feature">
                                            <p className="card-text mt-2">
                                              <strong>Total Present</strong>
                                            </p>
                                            <p className="h3 text-center text-success">{item.total_present_days}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div className="card bg-custom">
                                          <div className="card-body text-center feature">
                                            <p className="card-text mt-2">
                                              <strong>Total Absent</strong>
                                            </p>
                                            <p className="h3 text-center text-danger">{item.absent_days}</p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div className="card bg-custom">
                                          <div className="card-body text-center feature">
                                            <p className="card-text mt-2">
                                              <strong>Half day</strong>
                                            </p>
                                            <p className="h3 text-center text-warning">{item.half_day_present}</p>
                                          </div>
                                        </div>
                                      </div>

                                     
                                    </div>
                                  </>
                                }

                              </div>
                            ))
                          }
                          {attdet && attdet.length == 0 &&
                            <div className="d-md-flex ms-auto mb-2">
                              <label className="my-auto pt-2 exam-title"><strong>No Attendance Found</strong></label>
                            </div>
                          }
                        </div>
                      )} */}
                      {activeTab === "tab3" && (
                        <div className="col-sm-12 col-lg-12 col-xl-12">

                          {/* Attendance Summary Cards */}
                          {adetail &&
                            adetail.length > 0 &&
                            adetail.map((item, index) => (
                              <>
                                <div key={index} className="row row-cards mt-1">

                                  {item.attendance.length > 0 && (
                                    <>
                                      <h5 className="mb-3">{item.year}</h5>

                                      <div className="row">

                                        {/* Total Days */}
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Total Days</strong>
                                              </p>
                                              <p className="h3 text-info">
                                                {item.total_days}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Present */}
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Total Present</strong>
                                              </p>
                                              <p className="h3 text-success">
                                                {item.total_present_days}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Absent */}
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Total Absent</strong>
                                              </p>
                                              <p className="h3 text-danger">
                                                {item.absent_days}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Half Day */}
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Half Day</strong>
                                              </p>
                                              <p className="h3 text-warning">
                                                {item.half_day_present}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            ))}
                          <hr />
                                      <h5 className="mb-3">Monthly Attendance</h5>

                          {/* Calendar Legend */}
                          <div className="d-flex gap-4 align-items-center mt-4 mb-3" style={{ columnGap: "40px" }}>

                            <div className="d-flex align-items-center" >
                              <span
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "#28a745",
                                  display: "inline-block",
                                  marginRight: "8px",
                                  borderRadius: "3px",
                                }}
                              ></span>
                              <strong>Present</strong>
                            </div>

                            <div className="d-flex align-items-center">
                              <span
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "#dc3545",
                                  display: "inline-block",
                                  marginRight: "8px",
                                  borderRadius: "3px",
                                }}
                              ></span>
                              <strong>Absent</strong>
                            </div>

                            <div className="d-flex align-items-center">
                              <span
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "#ffc107",
                                  display: "inline-block",
                                  marginRight: "8px",
                                  borderRadius: "3px",
                                }}
                              ></span>
                              <strong>Half Day</strong>
                            </div>
                          </div>

                          {/* Full Calendar */}
                          {calatt.length > 0 ? (
                            <div className="card">
                              <div className="card-body">

                                <FullCalendar
                                  plugins={[dayGridPlugin]}
                                  initialView="dayGridMonth"
                                  height="auto"
                                  events={calatt}

                                  eventContent={(eventInfo) => {
                                    return (
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          padding: "2px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {eventInfo.event.title}
                                      </div>
                                    );
                                  }}
                                />

                              </div>
                            </div>
                          ) : (
                            <div className="d-md-flex ms-auto mb-2">
                              <label className="my-auto pt-2 exam-title">
                                <strong>No Attendance Found</strong>
                              </label>
                            </div>
                          )}
                        </div>
                      )}
                      {activeTab === "tab4" && (
                        <div className="timetable-container">
                          <table className="responsive-table">
                            <thead>
                              <tr>
                                <th>Lecture/Day</th>
                                <th>Monday</th>
                                <th>Tuesday</th>
                                <th>Wednesday</th>
                                <th>Thursday</th>
                                <th>Friday</th>
                                <th>Saturday</th>
                              </tr>
                            </thead>
                            <tbody>
                              {periods.length === 0 && (
                                <tr>
                                  <td colSpan="7">No timetable found</td>
                                </tr>
                              )}
                              {periods.map((period, index) => (
                                <tr key={index} className={index % 2 === 0 ? "even" : "odd"}>
                                  <td className={period.is_break === "Yes" ? "highlight" : ""}>
                                    <div className="period-name">{period.slot_name}</div>
                                    <div className="period-time">
                                      {period.from_time} - {period.to_time}
                                    </div>
                                  </td>
                                  {period.is_break === "Yes" ? (
                                    <td colSpan="6" className="highlight">{period.slot_name}</td>
                                  ) : (
                                    days.map((day, dayIndex) => (
                                      <td key={dayIndex}>
                                        {period.schedule[day] ? (
                                          <>
                                            <div><strong>{period.schedule[day].subject_name}</strong></div>
                                            <div>{period.schedule[day].teacher_name}</div>
                                          </>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    ))
                                  )}
                                </tr>
                              ))}
                              {/* {periods.length > 0 && periods.map((period, index) => (
                                <tr
                                  key={index}
                                  className={index % 2 === 0 ? "even" : "odd"}
                                >
                                  <td
                                    className={
                                      period.is_break == "Yes"
                                        ? "highlight"
                                        : ""
                                    }
                                  >
                                    <div className="period-name">{period.slot_name}</div>
                                    <div className="period-time">{period.from_time} - {period.to_time}</div>
                                  </td>
                                  {period.is_break == "Yes"  ?
                                    (<td colSpan="6">{period.slot_name}</td>) : (
                                      <>
                                        {period.schedule.map((schedule, dayIndex) => (
                                          <td
                                            key={dayIndex}
                                            className={
                                              schedule === "Break" || schedule === "Lunch"
                                                ? "highlight"
                                                : ""
                                            }
                                          >
                                            {schedule}
                                          </td>
                                        ))}
                                      </>
                                    )
                                  }



                                </tr>
                              ))} */}
                              {/* <tr className="break-rows">
                                <td><strong>Break</strong> <br />10:40 AM - 10:50 AM</td>
                                <td colSpan="6">Break</td>
                              </tr> */}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {activeTab === "tab5" && (
                        <Row className=" row-sm">
                          <div className="col-xl-4 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">From Date</label>
                              <input
                                type="date"
                                className="form-control"
                                value={fdate}
                                onChange={(e) => listall(e.target.value, tdate)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-4 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">To Date</label>
                              <input
                                type="date"
                                className="form-control"
                                value={tdate}
                                onChange={(e) => listall(fdate, e.target.value)}
                                min={fdate}
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            {hwlist.map((item, i) => (
                              <Card className=" mg-b-20 border" key={i}>
                                <div className="p-4 card-headerr">
                                  <div className="media">
                                    <div className="media-user me-2">
                                      <div className="main-img-user avatar-md">
                                        {item.teacher_photo !== null && (
                                          <img
                                            src={
                                              tpath +
                                              item.teacher_photo
                                            }
                                            alt="Student"
                                            onError={errorphoto}
                                          />
                                        )}
                                        {item.teacher_photo === null && (
                                          <img
                                            src={require("../../../assets/images/user.png")}
                                            alt="Student"
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div className="media-body">
                                      <h6 className="mb-0 mg-t-2 ms-2">
                                        {item.teacher_name}
                                        <span className="text-muted ms-2">
                                          {moment(item.created_at).format("MMM DD YYYY")}
                                        </span>
                                      </h6>
                                      <span className="text-primary ms-2">
                                        {item.subject_name}
                                      </span>
                                      <b className="text-danger ms-5">
                                        Due Date: {moment(item.due_date).format("DD-MM-YYYY")}
                                      </b>
                                    </div>
                                  </div>
                                </div>
                                <Card.Body>
                                  {/* <h3>All of you Read thgis file</h3> */}
                                  <p className="mg-t-0">{item.description}</p>
                                  <Row className=" row-sm">
                                    <div className="col">
                                      {item &&
                                        item.work_file &&
                                        (item.work_file.split(".").pop() === "pdf" ? (
                                          <a
                                            href={
                                              hwpath +
                                              item.academy_code +
                                              "/homework/" +
                                              item.work_file
                                            }
                                            target="_blank"
                                          >
                                            <img
                                              src={require("../../../assets/images/pdf.png")}
                                              alt="PDF File"
                                              width={"100px"}
                                              height={"100px"}
                                            />
                                          </a>
                                        ) : (
                                          <a
                                            href={
                                              hwpath +
                                              item.academy_code +
                                              "/homework/" +
                                              item.work_file
                                            }
                                            target="_blank"
                                          >
                                            <img
                                              src={hwpath +
                                                item.academy_code +
                                                "/homework/" +
                                                item.work_file}
                                              alt="Other File"
                                              width={"100px"}
                                              height={"100px"}
                                              onerror={(ev) => errorhome(ev)}
                                            />
                                          </a>
                                        ))}
                                    </div>
                                  </Row>
                                </Card.Body>
                              </Card>
                            ))}

                            {hwlist.length === 0 && (
                              <div className="d-md-flex ms-auto mb-2">
                                <label className="my-auto pt-2 exam-title"><strong>No Homework Found</strong></label>
                              </div>
                            )}
                          </div>
                        </Row>
                      )}
                      {activeTab === "tab6" && (
                        <div className="col-sm-12 col-lg-12 col-xl-12">
                          <div className="exam-result-container table-wrapper">
                            {edetail.length > 0 && edetail.map((item, index) => {
                              return (
                                <div key={index}>
                                  <div className="d-md-flex ms-auto mb-2">
                                    <label className="my-auto pt-2 exam-title"><strong>{item.exam} ({item.year})</strong></label>
                                  </div>
                                  <table className="result-table">
                                    <thead>
                                      <tr>
                                        <th>Subject</th>
                                        <th>Theory Marks</th>
                                        <th>Practical Marks</th>
                                        <th>Min Marks</th>
                                        <th>Marks Obtained</th>
                                        <th>Result</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.details.map((detail, j) => {
                                        const obtainedMarks = (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);
                                        const totalMarks = (detail.exam_details_theory_mark ?? 0) + (detail.exam_details_pratical_mark ?? 0);

                                        return (
                                          <tr key={j}>
                                            <td>{detail.subject_name} {detail.exam_date != null ? "(" + (moment(detail.exam_date).format("DD-MM-YYYY")) + ")" : ""} <br /> {detail.exam_time != null ? "(" + detail.exam_time + ")" : ""}</td>
                                            <td>{detail.exam_details_theory_mark != null ? detail.exam_details_theory_mark : ''}</td>
                                            <td>{detail.exam_details_pratical_mark != null ? detail.exam_details_pratical_mark : ''}</td>
                                            <td>{detail.pass_marks != null ? detail.pass_marks : ''}</td>
                                            <td>
                                              {obtainedMarks}
                                            </td>
                                            <td><span className={obtainedMarks >= detail.pass_marks ? "result-pass" : "result-fail"}>{obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}</span></td>

                                          </tr>
                                        )
                                      })}
                                    </tbody>
                                  </table>
                                  <div className="result-summary">
                                    <p><strong>Percentage:</strong> {calculatePercentage(item.details)}%</p>
                                    {/* <p><strong>Rank:</strong> 10</p> */}
                                    <p><strong>Result:</strong> <span className={item.details.some(detail => ((detail.theory_mark ?? 0) + (detail.practical_mark ?? 0)) < detail.pass_marks) ? 'result-fail' : 'result-pass'}>
                                      {item.details.some(detail => ((detail.theory_mark ?? 0) + (detail.practical_mark ?? 0)) < detail.pass_marks) ? 'Fail' : 'Pass'}
                                    </span></p>
                                    {/* <p><strong>Grade:</strong> A+</p> */}
                                    <p><strong>Grand Total:</strong> {calculateGrandTotal(item.details)}</p>
                                    <p className="text-success"><strong>Total Obtained Marks:</strong> {calculateTotalObtainedMarks(item.details)}</p>
                                  </div>
                                  <hr></hr>
                                </div>
                              )
                            })
                            }

                            {edetail.length === 0 && (
                              <div className="d-md-flex ms-auto mb-2">
                                <label className="my-auto pt-2 exam-title"><strong>No Record Found</strong></label>
                              </div>
                            )}
                            {/* <div className="d-md-flex ms-auto mb-2">
                              <label className="my-auto pt-2 exam-title"><strong>Chapter Wise Weekly Test (April-2024)</strong></label>
                            </div>
                            <table className="result-table">
                              <thead>
                                <tr>
                                  <th>Subject</th>
                                  <th>Max Marks</th>
                                  <th>Min Marks</th>
                                  <th>Marks Obtained</th>
                                  <th>Result</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>English (210)</td>
                                  <td>100.00</td>
                                  <td>33.00</td>
                                  <td>56.00</td>
                                  <td><span className="result-pass">Pass</span></td>
                                </tr>
                                <tr>
                                  <td>Mathematics (110)</td>
                                  <td>100.00</td>
                                  <td>33.00</td>
                                  <td>78.00</td>
                                  <td><span className="result-fail">Fail</span></td>
                                </tr>
                                <tr>
                                  <td>Hindi (230)</td>
                                  <td>100.00</td>
                                  <td>33.00</td>
                                  <td>56.00</td>
                                  <td><span className="result-pass">Pass</span></td>
                                </tr>
                                <tr>
                                  <td>Science (111)</td>
                                  <td>100.00</td>
                                  <td>33.00</td>
                                  <td>34.00</td>
                                  <td><span className="result-pass">Pass</span></td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="result-summary">
                              <p><strong>Percentage:</strong> 56.00</p>
                              <p><strong>Rank:</strong> 10</p>
                              <p><strong>Result:</strong> <span className="result-fail">Fail</span></p>
                              <p><strong>Grade:</strong> -</p>
                              <p><strong>Grand Total:</strong> 400</p>
                              <p className="text-danger"><strong>Total Obtained Marks:</strong> 224</p>
                            </div>
                            <hr></hr> */}
                          </div>

                        </div>
                      )}
                      {activeTab === "tab7" && (
                        <>
                          {sfees.length > 0 && sfees.map((data, j) => {
                            return (
                              <div key={j}>
                                <h5 >{data.academic}</h5>
                                <div className="row row-cards mt-1" >
                                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                    <div className="card bg-custom">
                                      <div className="card-body text-center feature">
                                        <p className="card-text mt-2">
                                          <strong>Total Fee</strong>
                                        </p>
                                        <p className="h3 text-center text-info">₹ {data.total.total_amount}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                    <div className="card bg-custom">
                                      <div className="card-body text-center feature">
                                        <p className="card-text mt-2">
                                          <strong>Total Paid Fee</strong>
                                        </p>
                                        <p className="h3 text-center text-success">₹ {data.total.paid_amount}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                    <div className="card bg-custom">
                                      <div className="card-body text-center feature">
                                        <p className="card-text mt-2">
                                          <strong> Pending Fee</strong>
                                        </p>
                                        <p className="h3 text-center text-danger">₹ {data.total.pending_amount}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">

                                    <Bar data={prepareChartData(data)} options={chartOptions} />
                                  </div>

                                </div>

                              </div>
                            )
                          })

                          }
                          {sfees.length === 0 && (
                            <div className="d-md-flex ms-auto mb-2">
                              <label className="my-auto pt-2 exam-title"><strong>No Record Found</strong></label>
                            </div>
                          )}
                        </>
                      )}
                      {activeTab === "tab8" && (
                        <>
                          <h5>Fees List</h5>
                          <div className="ag-theme-alpine ag-style mt-2">
                            <AgGridReact
                              columnDefs={columnDefs}
                              rowData={flist}
                              pagination="true"
                              paginationPageSize="10"
                              sortingOrder={["asc", "desc"]}
                              suppressDragLeaveHidesColumns={true}
                            />
                          </div>
                          <hr />
                          <h5>Fees History List</h5>
                          <div className="ag-theme-alpine ag-style mt-2">
                            <AgGridReact
                              columnDefs={columnHDefs}
                              rowData={fhlist}
                              pagination="true"
                              paginationPageSize="10"
                              sortingOrder={["asc", "desc"]}
                              suppressDragLeaveHidesColumns={true}
                            />
                          </div>
                        </>
                      )}
                      {activeTab === "tab9" && (
                        <div className="col-sm-12 col-lg-12 col-xl-12">
                          {certList.length === 0 ? (
                            <div className="d-md-flex ms-auto mb-2">
                              <label className="my-auto pt-2 exam-title"><strong>No Certificates Generated Yet</strong></label>
                            </div>
                          ) : (
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover mb-0">
                                <thead style={{ backgroundColor: "#b0b0b0" }}>
                                  <tr>
                                    <th>#</th>
                                    <th>Certificate Type</th>
                                    <th>Generated Date</th>
                                    <th>Total Generated</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {certList.map((cert, idx) => {
                                    const count = certList.filter(c => c.cert_type === cert.cert_type).length;
                                    return (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <i className="fa fa-certificate me-2" style={{ color: "#6259ca" }}></i>
                                          {cert.cert_label}
                                        </td>
                                        <td>{moment(cert.generated_date).format("DD-MM-YYYY")}</td>
                                        <td>
                                          <span className="badge bg-primary">{count} time{count !== 1 ? "s" : ""}</span>
                                        </td>
                                        <td>
                                          {cert.pdf_path && (
                                            <a
                                              className="btn btn-success btn-sm"
                                              href={cert.pdf_path.startsWith("http") ? cert.pdf_path : baseUrl + "/" + cert.pdf_path}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              download
                                            >
                                              <i className="fa fa-download me-1"></i> PDF
                                            </a>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
{/* {item.year.map((data, j) => {
                                  return (
                                    <>
                                      <h6>{data.type}</h6>

                                      <div className="row row-cards mt-1" key={j}>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Total Fee</strong>
                                              </p>
                                              <p className="h3 text-center text-info">₹ {data.total_amount}</p>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong>Total Paid Fee</strong>
                                              </p>
                                              <p className="h3 text-center text-success">₹ {data.paid_amount}</p>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                          <div className="card bg-custom">
                                            <div className="card-body text-center feature">
                                              <p className="card-text mt-2">
                                                <strong> Pending Fee</strong>
                                              </p>
                                              <p className="h3 text-center text-danger">₹ {data.pending_amount}</p>
                                            </div>
                                          </div>
                                        </div>



                                      </div>
                                    </>
                                  )
                                })

                                } */}
